import { render } from 'engine/index';
import { rpc } from 'src/backend';
import { Table, Td, Th, TrBody, TrHead } from './TableComponents';
import { Button } from './Button';
import type { ZintuigenState } from 'shared/modelTypes/facilitaire-zintuigen';

export function PlayZintuigen({ licenseCode }: { licenseCode: string }) {
	const view: HTMLElement = <div>Will play game {licenseCode}</div>;

	const sessionId = licenseCode;

	rpc.onAdminUpdates.subscribe(
		{ sessionId },
		{
			onData(data) {
				//
				if (data.kind === 'update-state') {
					const state = data.state as ZintuigenState;
					renderStage(state);
				}
			},
		},
	);

	const renderStage = (state: ZintuigenState) => {
		const s = state.stage;

		const game = state.game;

		switch (s) {
			case 'starting':
				render(view, <div class="animate-pulse text-xl text-gray-700">Starting play session</div>);
				break;
			case 'register-players':
				render(
					view,
					<PlayerRegisterView
						onContinue={() => {
							console.log('start the game');
							rpc.sendZintuigenMessage.query({ sessionId, update: { kind: 'start-game' } });
						}}
						state={state}
					/>,
				);
				break;
			case 'play-rounds':
				{
					const playerScreen = state.players[0].lastScreen.kind;

					render(
						view,
						<div>
							<h2 class="text-lg font-bold text-gray-900">
								Ronde {state.roundIndex + 1} - {game.rounds[state.roundIndex].topic}
							</h2>
							{playerScreen === 'show-story-screen' && (
								<div>
									<p>Geef uitleg in druk vervolgens op de knop om door te gaan.</p>

									<button
										class="mt-3 rounded-md bg-theme-600 px-3 py-1 text-theme-50 shadow-sm"
										on:click={() => rpc.sendZintuigenMessage.query({ sessionId, update: { kind: 'end-preface' } })}
									>
										Doorgaan
									</button>
									<PlayerTable state={state} />
								</div>
							)}
							{playerScreen === 'show-question-screen' && (
								<div>
									<p>Aan het wachten op antwoorden van de spelers.</p>
									<button
										class="mt-3 rounded-md bg-theme-600 px-3 py-1 text-theme-50 shadow-sm"
										on:click={() => rpc.sendZintuigenMessage.query({ sessionId, update: { kind: 'end-question' } })}
									>
										Meteen doorgaan
									</button>
									<PlayerTable state={state} />
								</div>
							)}
							{playerScreen == 'show-enter-tip-wait-screen' && (
								<div>
									<p>players are waiting to enter tips.</p>
									<button
										class="rounded-md bg-theme-600 px-3 py-1 text-theme-50 shadow-sm"
										on:click={() =>
											rpc.sendZintuigenMessage.query({
												sessionId,
												update: {
													kind: 'show-enter-tip-screen',
												},
											})
										}
									>
										show enter tip screen
									</button>
									<PlayerTable state={state} />
								</div>
							)}
							{playerScreen === 'show-enter-tip-screen' && (
								<div>
									<p>Aan het wachten op antwoorden van de spelers.</p>
									<button
										class="mt-3 rounded-md bg-theme-600 px-3 py-1 text-theme-50 shadow-sm"
										on:click={() => rpc.sendZintuigenMessage.query({ sessionId, update: { kind: 'end-question' } })}
									>
										Meteen doorgaan
									</button>
									<PlayerTable state={state} />
								</div>
							)}
							{playerScreen == 'show-answer-wait-screen' && (
								<div>
									<p>players are waiting for answers.</p>
									<button
										class="rounded-md bg-theme-600 px-3 py-1 text-theme-50 shadow-sm"
										on:click={() =>
											rpc.sendZintuigenMessage.query({
												sessionId,
												update: {
													kind: 'show-question-results',
												},
											})
										}
									>
										Show answers
									</button>
									<PlayerTable state={state} />
								</div>
							)}
							{playerScreen === 'show-answer-screen' && (
								<div>
									<p class="mb-3">
										Players are viewing the answer. Use dropdowns to select golden/silver tip and click next to show
										result.
									</p>

									<label class="font-bold">Functionele tip:</label>
									<select class="my-2 rounded-md border border-gray-300 p-1" id="golden-tip">
										<option selected value="">
											Niemand
										</option>
										{state.players.map((p) => (
											<option value={p.id}>
												{p.name} - {p.color}
											</option>
										))}
									</select>
									<br />
									<label class="font-bold">Gastgerichte tip:</label>
									<select class="my-2 rounded-md border border-gray-300 p-1" id="silver-tip">
										<option selected value="">
											Niemand
										</option>
										{state.players.map((p) => (
											<option value={p.id}>
												{p.name} - {p.color}
											</option>
										))}
									</select>
									<br />

									<button
										class="rounded-md bg-theme-600 px-3 py-1 text-theme-50 shadow-sm"
										on:click={() =>
											rpc.sendZintuigenMessage.query({
												sessionId,
												update: {
													kind: 'show-tip-results',
													goldenTipPlayerId: (document.getElementById('golden-tip') as HTMLSelectElement)?.value,
													silverTipPlayerId: (document.getElementById('silver-tip') as HTMLSelectElement)?.value,
												},
											})
										}
									>
										Next
									</button>
									<PlayerTable state={state} />
								</div>
							)}

							{playerScreen === 'show-tip-screen' && (
								<div>
									<p class="mb-3">Tips aan het tonen. Druk op de knop om door te gaan.</p>

									<button
										class="rounded-md bg-theme-600 px-3 py-1 text-theme-50 shadow-sm"
										on:click={() =>
											rpc.sendZintuigenMessage.query({
												sessionId,
												update: { kind: 'start-next-round' },
											})
										}
									>
										Volgende ronde
									</button>
									<PlayerTable state={state} />
								</div>
							)}
						</div>,
					);
				}
				break;
			case 'ending-report':
				render(
					view,
					<div>
						<p>Showing ending report</p>
					</div>,
				);
				break;
		}
	};

	// render initial state
	(async () => {
		const state = await rpc.getGameState.query({ sessionId });
		console.log(state);
		renderStage(state);
	})();

	return view;
}

function PlayerRegisterView({ state, onContinue }: { state: ZintuigenState; onContinue: () => void }) {
	console.log('render players', state.players);

	const playersWithName = state.players.filter((p) => p.name);

	return (
		<div>
			<h3 class="text-lg font-bold text-gray-800 dark:text-gray-200">Spelers registreren</h3>
			<p class="mb-5 text-gray-700">
				Laat spelers de QR code op het bord scannen en vervolgens hun gegevens invullen.
				<br />
				Druk op <strong>doorgaan</strong> als alle spelers gereed zijn.
			</p>
			{playersWithName.length > 0 && (
				<Table>
					<thead>
						<TrHead>
							<Th>Name</Th>
							<Th>Color</Th>
							<Th>Id</Th>
						</TrHead>
					</thead>
					<tbody>
						{playersWithName.map((player) => {
							return (
								<TrBody>
									<Td>{player.name}</Td>
									<Td>{player.color}</Td>
									<Td>{player.id}</Td>
								</TrBody>
							);
						})}
					</tbody>
				</Table>
			)}
			{!playersWithName.length && <small class="text-gray-700">Er zijn nog geen spelers.</small>}
			<div class="mt-5"></div>
			<Button on:click={onContinue}>Doorgaan</Button>
		</div>
	);
}

function PlayerTable({ state }: { state: ZintuigenState }) {
	return (
		<Table>
			<thead>
				<TrHead>
					<Th>Name</Th>
					<Th>Color</Th>
					<Th>Punten</Th>
					<Th>Antwoord</Th>
					<Th>Tip</Th>
					<Th>id</Th>
				</TrHead>
			</thead>
			<tbody>
				{state.players.map((player) => {
					return (
						<TrBody>
							<Td>{player.name}</Td>
							<Td>{player.color}</Td>
							<Td>{player.score}</Td>
							<Td>{player.roundAnswers[state.roundIndex]?.emotion ?? ''}</Td>
							<Td>{player.roundTips[state.roundIndex]?.tip ?? ''}</Td>
							<Td>{player.id}</Td>
						</TrBody>
					);
				})}
			</tbody>
		</Table>
	);
}
